import { del, get, post, put } from '../../utils/axios'
const path = 'leave/type'

export const listSettingLeaveTypeAllAPI = async (body) => {
  return await get('leave/type/all', body)
}
export const updateSettingLeaveTypeDateAPI = async (body) => {
  return await post('leave/type/update/date', body)
}
export const getLeveTypeV2API = async (params) => {
  return await get(`${path}`, params, {}, 'v2')
}
export const putLeveTypeV2API = async (params, body) => {
  return await put(`${path}`, params, body, 'v2')
}
export const postLeveTypeV2API = async (params) => {
  return await post(`${path}`, params, 'v2')
}
export const delLeveTypeV2API = async (params) => {
  return await del(`${path}`, params, {}, 'v2')
}
export const getDetailLeveTypeV2API = async (params) => {
  return await get(`${path}/detail`, params, {}, 'v2')
}
export const putAssignLeveTypeV2API = async (body) => {
  return await put(`${path}/assign`, {}, body, 'v2')
}
export const delAssignLeveTypeV2API = async (body) => {
  return await del(`${path}/unassign`, {}, body, 'v2')
}
